export const NODE_ENV_PRODUCTION: string = 'production';
export const NODE_ENV_DEVELOPMENT: string = 'development';
